import { render, staticRenderFns } from "./BannerTheme2.vue?vue&type=template&id=2b85cb67"
import script from "./BannerTheme2.vue?vue&type=script&lang=js"
export * from "./BannerTheme2.vue?vue&type=script&lang=js"
import style0 from "./BannerTheme2.vue?vue&type=style&index=0&id=2b85cb67&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports